/* ====================================================================
   DIVEIN 主题自定义 JS — divein-overrides.js
   全站交互/动画统一入口，新增功能往这里堆
   ==================================================================== */
(function(){
  'use strict';

  /* ---------- 1. 全局滚动进场动画（reveal class） ----------
     给带 .reveal 的元素加 .in 触发淡入上移
     支持 stagger delay：.d1/.d2/.d3/.d4（60-240ms）
     尊重 prefers-reduced-motion */
  function initReveal(){
    if(!('IntersectionObserver' in window)){
      document.querySelectorAll('.reveal').forEach(function(el){el.classList.add('in');});
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
      });
    },{threshold:0.12, rootMargin:'0px 0px -8% 0px'});
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  }

  /* ---------- 2. 后续可扩展占位 ----------
     以后加新功能在这里写，比如：
     - 数量加减、移除购物车
     - 收藏 wishlist 切换
     - FAQ 折叠
     - 对比页移除列
     - sticky 加购条
     每个功能一段，加注释标题 */

  /* ---------- 启动 ---------- */
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initReveal);
  }else{
    initReveal();
  }
  /* 路由切换/懒加载后新增的 .reveal 元素也要触发 */
  if('MutationObserver' in window){
    var mo = new MutationObserver(function(muts){
      muts.forEach(function(m){
        m.addedNodes && m.addedNodes.forEach(function(n){
          if(n.nodeType === 1 && n.classList && n.classList.contains('reveal')){
            if('IntersectionObserver' in window){
              var io2 = new IntersectionObserver(function(es){
                es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io2.unobserve(e.target);}});
              },{threshold:0.12});
              io2.observe(n);
            }else{n.classList.add('in');}
          }
        });
      });
    });
    mo.observe(document.body,{childList:true,subtree:true});
  }
})();


/* ===== DIVEIN · Policies 政策页：tab 切换 + URL 锚点定位 ===== */
(function(){
  function activate(root, key){
    var tabs   = root.querySelectorAll('.dvp-tab');
    var panels = root.querySelectorAll('.dvp-panel');
    var hit = false;
    tabs.forEach(function(t){
      var on = t.classList.contains('dvp-tab-' + key);
      t.classList.toggle('active', on);
      if(on) hit = true;
    });
    panels.forEach(function(p){
      p.classList.toggle('active', p.classList.contains('dvp-panel-' + key));
    });
    return hit;
  }

  function initPolicies(){
    document.querySelectorAll('.dv-policy').forEach(function(root){
      var tabs = root.querySelectorAll('.dvp-tab');
      if(!tabs.length) return;

      /* 1) 点击 tab：切换板块，并把锚点同步到地址栏（不产生历史记录） */
      tabs.forEach(function(a){
        a.addEventListener('click', function(e){
          e.preventDefault();
          var key = (a.getAttribute('href') || '').replace('#','');
          if(!key) return;
          activate(root, key);
          if(history.replaceState) history.replaceState(null, '', '#' + key);
        });
      });

      /* 2) 进页面时按 URL 上的锚点自动展开对应板块（菜单 / footer 跳进来时生效） */
      var key = (location.hash || '').replace('#','');
      if(key && activate(root, key)){
        var panel = root.querySelector('.dvp-panel-' + key);
        if(panel && panel.scrollIntoView){
          setTimeout(function(){
            panel.scrollIntoView({behavior:'smooth', block:'start'});
          }, 120);
        }
      }

      /* 同步各 panel 高度：量出最高的，给所有 panel 设 min-height
        → 切 tab 时 footer 不再上下跳；窗口 resize 时重新量 */
      var resizeTimer;
      function syncPanelHeight(){
        var panels = root.querySelectorAll('.dvp-panel');
        if(!panels.length) return;
        /* 临时全显示才能量到真实高度（display:none 时高度=0） */
        var states = [];
        panels.forEach(function(p, i){
          states[i] = p.classList.contains('active');
          p.classList.add('active');
        });
        requestAnimationFrame(function(){
          var max = 0;
          panels.forEach(function(p){
            var h = p.offsetHeight;        /* 含 padding+border */
            if(h > max) max = h;
          });
          panels.forEach(function(p, i){
            if(!states[i]) p.classList.remove('active');
            if(max > 0) p.style.minHeight = max + 'px';
          });
        });
      }
      syncPanelHeight();
      window.addEventListener('resize', function(){
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(syncPanelHeight, 120);
      });

      /* 4) 已在本页时，点上方二级菜单 / 底部 footer 切换锚点（页面不刷新、仅 hash 变）→ 也要响应 */
      function gotoKey(){
        var key = (location.hash || '').replace('#','');
        if(key && activate(root, key)){
          var panel = root.querySelector('.dvp-panel-' + key);
          if(panel && panel.scrollIntoView){
            panel.scrollIntoView({behavior:'smooth', block:'start'});
          }
          syncPanelHeight();   /* 板块内容长度不同，重新对齐一次高度，footer 不跳 */
        }
      }
      window.addEventListener('hashchange', gotoKey);
    });
  }

    /* FAQ 手风琴：同组只开一个 */
    (function(){
      document.querySelectorAll('[data-faq]').forEach(function(group){
        var items = group.querySelectorAll('.faq-item');
        items.forEach(function(it){
          var btn = it.querySelector('.faq-q');
          var ans = it.querySelector('.faq-a');
          btn.addEventListener('click', function(){
            var isOpen = it.classList.contains('open');
            items.forEach(function(o){
              o.classList.remove('open');
              o.querySelector('.faq-a').style.maxHeight = null;
            });
            if(!isOpen){
              it.classList.add('open');
              ans.style.maxHeight = ans.scrollHeight + 'px';
            }
          });
        });
      });
    })();
  
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initPolicies);
  }else{
    initPolicies();
  }

  
})();

/* ===== BLOG 列表：3D 水下背景（仅 template-blog） ===== */
(function(){
  if (typeof THREE === 'undefined') return;
  if (!document.body.classList.contains('template-blog')) return;
  var container = document.getElementById('blog-canvas-bg');
  if (!container) return;
  var scene = new THREE.Scene();
  scene.fog = new THREE.FogExp2(0x001a2e, 0.015);
  var camera = new THREE.PerspectiveCamera(75, window.innerWidth/window.innerHeight, 0.1, 1000);
  camera.position.set(0,0,10);
  var renderer = new THREE.WebGLRenderer({antialias:true, alpha:true});
  renderer.setSize(window.innerWidth, window.innerHeight);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio,2));
  container.appendChild(renderer.domElement);
  scene.add(new THREE.AmbientLight(0x0066aa,0.4));
  var sunLight = new THREE.DirectionalLight(0x88ddff,0.8); sunLight.position.set(5,20,5); scene.add(sunLight);
  var rayGeo = new THREE.PlaneGeometry(3,40);
  for (var i=0;i<8;i++){ var r = new THREE.Mesh(rayGeo, new THREE.MeshBasicMaterial({color:0x88ddff, transparent:true, opacity:0.04, side:THREE.DoubleSide})); r.position.set((Math.random()-0.5)*30,10,(Math.random()-0.5)*10-5); r.rotation.z=(Math.random()-0.5)*0.3; r.rotation.x=Math.PI/2+(Math.random()-0.5)*0.2; scene.add(r); }
  var bubbleCount=180, bGeo=new THREE.SphereGeometry(0.08,8,8), bMat=new THREE.MeshPhongMaterial({color:0xaaddff,transparent:true,opacity:0.3,shininess:100});
  var bubbles=new THREE.Group(), bData=[];
  for (var i=0;i<bubbleCount;i++){ var b=new THREE.Mesh(bGeo,bMat); var s=Math.random()*0.15+0.03; b.scale.setScalar(s); b.position.set((Math.random()-0.5)*30,Math.random()*40-20,(Math.random()-0.5)*20); bubbles.add(b); bData.push({speed:Math.random()*0.03+0.01,wobble:Math.random()*Math.PI*2,wobbleSpeed:Math.random()*0.02+0.01}); }
  scene.add(bubbles);
  var pCount=400, pGeo=new THREE.BufferGeometry(), pPos=new Float32Array(pCount*3);
  for (var i=0;i<pCount*3;i+=3){ pPos[i]=(Math.random()-0.5)*50; pPos[i+1]=(Math.random()-0.5)*50; pPos[i+2]=(Math.random()-0.5)*30; }
  pGeo.setAttribute('position', new THREE.BufferAttribute(pPos,3));
  var particles = new THREE.Points(pGeo, new THREE.PointsMaterial({color:0x88ccff,size:0.05,transparent:true,opacity:0.4})); scene.add(particles);
  var isDragging=false, prevMouse={x:0,y:0}, camY=0, camX=0, tgtY=0, tgtX=0;
  renderer.domElement.addEventListener('mousedown', function(e){ isDragging=true; prevMouse={x:e.clientX,y:e.clientY}; });
  window.addEventListener('mousemove', function(e){ var mx=(e.clientX/window.innerWidth)*2-1, my=(e.clientY/window.innerHeight)*2-1; tgtY=mx*0.12; tgtX=my*0.08; if(isDragging){ tgtY+=(e.clientX-prevMouse.x)*0.005; tgtX+=(e.clientY-prevMouse.y)*0.005; tgtX=Math.max(-0.8,Math.min(0.8,tgtX)); prevMouse={x:e.clientX,y:e.clientY}; } });
  window.addEventListener('mouseup', function(){ isDragging=false; });
  var scrollY=0, targetScrollY=0; window.addEventListener('scroll', function(){ targetScrollY=window.scrollY; });
  var clock=new THREE.Clock();
  function animate(){
    requestAnimationFrame(animate);
    var t=clock.getElapsedTime();
    scrollY += (targetScrollY-scrollY)*0.05;
    var maxScroll=document.body.scrollHeight-window.innerHeight;
    var progress=maxScroll>0?Math.min(scrollY/maxScroll,1):0;
    camera.position.y += (-progress*25-camera.position.y)*0.05;
    camY += (tgtY-camY)*0.05; camX += (tgtX-camX)*0.05;
    camera.rotation.y=camY; camera.rotation.x=camX;
    scene.fog.color.setRGB(0,0.1-progress*0.05,0.18-progress*0.08);
    sunLight.intensity=0.8-progress*0.5;
    bubbles.children.forEach(function(b,i){ var d=bData[i]; b.position.y+=d.speed; b.position.x+=Math.sin(t*d.wobbleSpeed+d.wobble)*0.005; if(b.position.y>20){ b.position.y=-20; b.position.x=(Math.random()-0.5)*30; } });
    particles.rotation.y=t*0.02;
    renderer.render(scene,camera);
  }
  animate();
  window.addEventListener('resize', function(){ camera.aspect=window.innerWidth/window.innerHeight; camera.updateProjectionMatrix(); renderer.setSize(window.innerWidth, window.innerHeight); });
})();

/* ===== BLOG 列表：日期只留日期，去掉 "By XXX"（CSS 搞不定时兜底） ===== */
(function(){
  if (!document.body.classList.contains('template-blog')) return;
  document.querySelectorAll('.wrap-date').forEach(function(el){
    var txt = el.textContent.trim();
    var m = txt.match(/^([A-Za-z]{3}\s+\d{1,2},?\s+\d{4})/);
    if (m) el.textContent = m[1];
  });
})();

/* [13b] 详情页：精确删除 main-info-post 里的摘要纯文本节点（.des 之前那段），不影响 .des 落地页 */
(function () {
  if (!document.body.classList.contains('template-article')) return;
  function run() {
    document.querySelectorAll('.main-info-post').forEach(function (box) {
      Array.prototype.slice.call(box.childNodes).forEach(function (n) {
        if (n.nodeType === 3 && n.textContent.trim() !== '') n.remove();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* COLIN — /cart 运费估算块折叠（默认收起，点标题展开） */
(function(){
  function init(){
    /* ⚠️ 边栏 #addon_shipping 里也有一个 #shipping-calculator，必须排除 */
    var all = document.querySelectorAll('#shipping-calculator');
    var box = null;
    for(var i=0;i<all.length;i++){
      if(!all[i].closest('#js_cart_popup')){ box = all[i]; break; }
    }
    if(!box || box.getAttribute('data-dv-collapsible')) return;
    box.setAttribute('data-dv-collapsible','1');

    /* 复用里面原有的标题文字（如 "Estimate shipping rates"），避免展开后两个标题 */
    var inner = box.querySelector('h5, h6, .title');
    var titleText = inner ? inner.textContent.trim() : 'Estimate shipping rates';
    if(inner) inner.style.display = 'none';

    var bar = document.createElement('div');
    bar.className = 'dv-collapse-bar';
    bar.setAttribute('role','button');
    bar.setAttribute('tabindex','0');
    bar.setAttribute('aria-expanded','false');

    var label = document.createElement('span');
    label.className = 'dv-collapse-title';
    label.textContent = titleText;

    var icon = document.createElement('span');
    icon.className = 'dv-collapse-icon';

    bar.appendChild(label);
    bar.appendChild(icon);

    var content = document.createElement('div');
    content.className = 'dv-collapse-content';
    while(box.firstChild){ content.appendChild(box.firstChild); }

    box.appendChild(bar);
    box.appendChild(content);
    content.style.display = 'none';

    function toggle(){
      var open = box.classList.toggle('dv-open');
      bar.setAttribute('aria-expanded', open ? 'true' : 'false');
      content.style.display = open ? '' : 'none';
    }
    bar.addEventListener('click', toggle);
    bar.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); toggle(); }
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();


/* ====================================================================
   ↓↓↓ 以下整段追加到 divein-overrides.js 末尾 ↓↓↓
   公告栏闪烁动效 + 字号设置 + 手机端显示
   （本段整体是一个独立 IIFE，直接追加即可，不会与上方代码冲突）
   ==================================================================== */

/* ====================================================================
   DIVEIN 公告栏动效  —  divein-announce-fx.js
   --------------------------------------------------------------------
   作用：给顶部公告栏（.announcement-bar__message）加「闪烁 / 跑马灯 /
         轮播 / 流光」效果，并做必要的 DOM 改造。
   安装：Assets → Add a new asset → 文件名 divein-announce-fx.js
         内容整份粘进去 → Save
         然后 Layout/theme.liquid 的 </body> 前加一行：
         {{ 'divein-announce-fx.js' | asset_url | script_tag }}
   模式：在本文件顶部的 CFG.mode 里改（'blink' | 'marquee' | 'rotate' | 'shine' | 'off'）
         也支持网址后面加 #marquee / #blink / #rotate / #shine 临时切换（预览用）
   注意：轮播模式会把文案拆成多段。要改文案请回后台改，本文件不含文案内容。
   ==================================================================== */
(function(){
  'use strict';

  /* ================= 可调参数（改这里就行） ================= */
  var CFG = {
    mode: 'rotate',          /* blink | marquee | rotate | shine | off */
    marqueeSpeed: 22,      /* 跑马灯跑一圈几秒 */
    rotateSpeed: 12,        /* 轮播一轮几秒 */
    blinkSpeed: 4.5,       /* 闪烁周期（秒） */
    shineSpeed: 3.4,       /* 流光扫一遍（秒） */
    hoverPause: true,      /* 鼠标悬停时暂停 */
    separator: '·',        /* 轮播模式按这个符号切分文案 */
    minText: 12,           /* 轮播模式：短于这个字数就不切，改用闪烁 */

    /* ---------- 字号（后台没有字号设置项，只能在这里调）----------
       单位 px。桌面端与 ≤768px 手机端可分开设。
       主题原本继承 .cms-top-header .topbar 的 14px，所以这里默认 14 / 12。
       想加粗促销感 → 桌面端改 16 或 18。 */
    fontSizeDesktop: 18,
    fontSizeMobile: 12,

    /* ---------- 手机/平板是否显示公告栏 ----------
       主题 schema 里 "Hide (mobile)" 默认是 **勾选**的，
       勾了会给 wrapper 加 .hide-mobile class，
       主题 CSS 在 @media (max-width:1024px) 里直接 display:none !important
       → 手机和平板上整条公告栏看不到。

       这里设为 true = 强制在手机/平板也显示（会覆盖 hide-mobile）。
       想继续用后台的「Hide (mobile)」开关，就保持 false。 */
    showOnMobile: true,

    /* ---------- 左对齐 ----------
       后台 text align 选 Left 就能左对齐（线上实测桌面端确实是左对齐），
       所以默认关闭，不用代码。
       ⚠ 主题 header.css:3786 在 @media (max-width:1024px) 里
         把 .wrapper-bar-message / .topbar-left 强制成 text-align:center，
         但那段同时也被 .hide-mobile 的 display:none 盖住了 → 看不到。
         所以只要 showOnMobile=true 且想在手机端左对齐，
         这里也要改成 true。 */
    alignLeft: false
  };
  /* ========================================================== */

  var MODE_KEYS = ['blink','marquee','rotate','shine'];

  function pickMode(){
    /* 网址 hash 优先，方便临时预览：#marquee */
    var h = (location.hash || '').replace('#','').toLowerCase();
    if (MODE_KEYS.indexOf(h) >= 0) return h;
    return CFG.mode;
  }

  /* ---------- 找到公告栏文字容器（页面上可能有多处） ---------- */
  function findAllMsg(){
    /* 主题里是 .announcement-bar__message > p（richtext 会包一层 p）
       优先取内部的 p，取不到就取容器本身。
       ⚠ 原始 HTML 必须存在元素自身上（__dvAnnOrigHTML），
         不能存在返回对象里 —— findAllMsg 每次都会新建对象，
         存对象上会导致第二次 initAnnounce 把「已被改造的 DOM」当成原文，越改越乱。 */
    var out = [];
    var boxes = document.querySelectorAll('.announcement-bar__message');
    for (var i = 0; i < boxes.length; i++){
      var box = boxes[i];
      var p = box.querySelector('p');
      var el = p || box;
      if (el.__dvAnnOrigHTML === undefined){
        el.__dvAnnOrigHTML = el.innerHTML;
      }
      /* wrapper = .announcement-bar__message 的父元素（.wrapper-bar-message），
         它的 class 里可能带 hide-mobile → 手机/平板整条被 display:none 掉 */
      out.push({
        box: box,
        text: el,
        origHTML: el.__dvAnnOrigHTML,
        wrapper: box.parentElement
      });
    }
    return out;
  }

  /* ---------- 读出纯文本（去掉链接按钮） ---------- */
  function readText(el){
    var clone = el.cloneNode(true);
    var links = clone.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) links[i].remove();
    return (clone.textContent || '').replace(/\s+/g, ' ').trim();
  }

  /* ---------- 取「保留内联格式」的 HTML 副本（去掉链接按钮） ----------
     marquee 用它复制两份，保住 <strong> 等标签 */
  function getCleanHTML(el){
    var clone = el.cloneNode(true);
    var links = clone.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) links[i].remove();
    return clone.innerHTML;
  }

  /* ---------- 按分隔符切分，且保留内联格式 ----------
     关键点：
     1) 用 splitText 在分隔符处精确切开文本节点，再插入 marker 元素。
        （不要用 TreeWalker + replaceChild，会把文字挪出 <strong>）
     2) 分组时遇到「内含 marker 的元素」要克隆该元素分投到各组，
        否则 strong 会被拆散。
     只用 textContent 切会把 <strong> 等格式吃掉，这里必须保 DOM 结构。 */
  function splitBySeparator(el, sep){
    var clone = el.cloneNode(true);
    var as = clone.querySelectorAll('a');
    for (var i = 0; i < as.length; i++) as[i].remove();

    /* --- 1) 收集所有分隔符位置 --- */
    var walker = document.createTreeWalker(clone, NodeFilter.SHOW_TEXT, null, false);
    var cuts = [];          /* {node, offset} */
    var t;
    while ((t = walker.nextNode())){
      if (!t.nodeValue) continue;
      var idx = t.nodeValue.indexOf(sep);
      while (idx !== -1){
        cuts.push({ node: t, offset: idx });
        idx = t.nodeValue.indexOf(sep, idx + sep.length);
      }
    }

    /* --- 2) 从后往前切（前面的 offset 才不会失效） --- */
    for (var c = cuts.length - 1; c >= 0; c--){
      var cut = cuts[c];
      var after = cut.node.splitText(cut.offset);   /* cut.node 留前半，after 是后半 */
      if (after.nodeValue && after.nodeValue.length >= sep.length){
        after.deleteData(0, sep.length);             /* 删掉分隔符本身 */
      }
      var marker = document.createElement('span');
      marker.setAttribute('data-dv-sep', '');
      after.parentNode.insertBefore(marker, after);
    }

    /* --- 3) 按 marker 分组 --- */
    function splitChildren(parent){
      var groups = [[]];
      var kids = Array.prototype.slice.call(parent.childNodes);
      for (var i = 0; i < kids.length; i++){
        var c = kids[i];
        /* 顶层 marker → 分组边界 */
        if (c.nodeType === 1 && c.hasAttribute('data-dv-sep')){
          groups.push([]);
          continue;
        }
        /* 元素内部还藏着 marker（如 <strong>A · B</strong>）
           → 拆这个元素，各段分别克隆一份投到对应组 */
        if (c.nodeType === 1 && c.querySelector('[data-dv-sep]')){
          var inner = splitChildren(c);
          for (var g = 0; g < inner.length; g++){
            if (g > 0) groups.push([]);
            if (!inner[g].length) continue;
            var part = c.cloneNode(false);           /* 浅克隆，保留 <strong> 本身 */
            inner[g].forEach(function(n){ part.appendChild(n); });
            groups[groups.length - 1].push(part);
          }
          continue;
        }
        groups[groups.length - 1].push(c);
      }
      return groups;
    }

    var groups = splitChildren(clone);

    /* --- 4) 每组包成一个 span --- */
    var out = [];
    groups.forEach(function(nodes){
      var span = document.createElement('span');
      nodes.forEach(function(n){ span.appendChild(n); });
      var txt = (span.textContent || '').replace(/\s+/g, ' ').trim();
      if (txt) out.push(span);
    });
    return out;
  }

  /* ---------- 还原到原始状态 ---------- */
  function restore(msg){
    msg.text.classList.remove('dv-ann-fallback-blink');
    msg.text.style.animationDuration = '';
    msg.text.style.removeProperty('--dv-ann-color');
    msg.text.innerHTML = msg.origHTML;   /* 用原始 HTML 还原，保留 <strong> 等 */
  }

  /* ---------- 模式 1：闪烁 ---------- */
  function applyBlink(){
    /* 注意：模式 class 一律加在 <html> 上，与 CSS 的 html.dv-ann-xxx 选择器对应 */
    document.documentElement.classList.add('dv-ann-blink');
  }

  /* ---------- 模式 4：流光 ---------- */
  function applyShine(msg){
    /* 取出实际文字颜色当流光主色 */
    var cs = window.getComputedStyle(msg.text);
    var color = cs.color || '#F3F0FA';
    msg.text.style.setProperty('--dv-ann-color', color);
    document.documentElement.classList.add('dv-ann-shine');
  }

  /* ---------- 模式 3：轮播（一句一句往上翻） ---------- */
  function applyRotate(msg){
    var raw = readText(msg.text);
    var parts = splitBySeparator(msg.text, CFG.separator);

    /* 只有一句 / 太短 → 退回闪烁 */
    if (parts.length < 2 || raw.length < CFG.minText){
      applyBlink();
      return;
    }

    var holder = document.createElement('span');
    holder.className = 'dv-ann-rot';

    parts.forEach(function(partEl, i){
      var item = document.createElement('span');
      item.appendChild(partEl);          /* 保留 <strong> 等内联格式 */
      /* 每条错开一个身位，形成接力 */
      item.style.animationDelay = (i * (CFG.rotateSpeed / parts.length)) + 's';
      holder.appendChild(item);
    });

    msg.text.innerHTML = '';
    msg.text.appendChild(holder);
    document.documentElement.classList.add('dv-ann-rotate');
  }

  /* ---------- 模式 2：跑马灯 ---------- */
  function applyMarquee(msg){
    var raw = readText(msg.text);
    if (!raw.length){ applyBlink(); return; }

    var html = getCleanHTML(msg.text);     /* 保留 <strong> 等内联格式 */
    var track = document.createElement('span');
    track.className = 'dv-ann-track';

    /* 复制两份 → 位移 -50% 时无缝衔接 */
    for (var k = 0; k < 2; k++){
      var copy = document.createElement('span');
      copy.className = 'dv-ann-copy';
      copy.innerHTML = html;
      if (k === 1) copy.setAttribute('aria-hidden', 'true');
      track.appendChild(copy);
    }

    msg.text.innerHTML = '';
    msg.text.appendChild(track);
    document.documentElement.classList.add('dv-ann-marquee');

    /* 量一下：内容比容器短就改成小幅左右摆，别让尾部露白 */
    requestAnimationFrame(function(){
      var one = track.querySelector('.dv-ann-copy');
      if (!one) return;
      /* 用 rect 而不是 scrollWidth —— copy 里现在含 <strong> 等内联标签，
         scrollWidth 会受行内盒影响，rect 更接近实际视觉宽度 */
      var textW = one.getBoundingClientRect().width;
      var boxW = msg.text.clientWidth;
      if (textW > 0 && boxW > 0 && textW < boxW){
        track.classList.remove('is-loop');
        track.classList.add('is-swing');
        /* 摆动幅度最多走完剩余空间的一半，观感更稳 */
        var shift = Math.max(0, boxW - textW);
        track.style.setProperty('--dv-ann-shift', Math.round(shift * 0.5) + 'px');
      } else {
        track.classList.add('is-loop');
      }
    });
  }

  /* ---------- 主流程 ---------- */
  function initAnnounce(){
    var mode = pickMode();
    var html = document.documentElement;

    /* 清掉上一轮效果（模式切换时用） */
    MODE_KEYS.forEach(function(k){ html.classList.remove('dv-ann-' + k); });

    var list = findAllMsg();
    if (!list.length) return;

    /* 首次读取时缓存原始 HTML，后续还原用（缓存挂在元素上，见 findAllMsg 注释） */
    list.forEach(function(msg){ restore(msg); });

    if (mode === 'off') return;

    /* 速度变量 */
    html.style.setProperty('--dv-ann-marquee-speed', CFG.marqueeSpeed + 's');
    html.style.setProperty('--dv-ann-rotate-speed', CFG.rotateSpeed + 's');
    html.style.setProperty('--dv-ann-blink-speed', CFG.blinkSpeed + 's');
    html.style.setProperty('--dv-ann-shine-speed', CFG.shineSpeed + 's');

    /* 字号变量（后台没有字号设置项，只能靠这个） */
    html.style.setProperty('--dv-ann-font-size', CFG.fontSizeDesktop + 'px');
    html.style.setProperty('--dv-ann-font-size-mobile', CFG.fontSizeMobile + 'px');

    if (CFG.hoverPause) html.classList.add('dv-ann-hoverpause');

    /* 手机/平板强制显示
       主题 schema 的 "Hide (mobile)" 默认勾选 → wrapper 带 .hide-mobile
       → @media(max-width:1024px) 里 display:none !important，整条看不见。
       CFG.showOnMobile = true 时把它去掉。 */
    if (CFG.showOnMobile){
      html.classList.add('dv-ann-show-mobile');
      list.forEach(function(msg){
        if (msg.wrapper && msg.wrapper.classList.contains('hide-mobile')){
          msg.wrapper.classList.remove('hide-mobile');
          msg.wrapper.setAttribute('data-dv-ann-forced-mobile', '1');
        }
      });
    } else {
      html.classList.remove('dv-ann-show-mobile');
    }

    /* 强制左对齐（默认关闭 —— 后台 text align 选 Left 即可）。
       只有当主题在 ≤1024px 强制居中、导致后台的 Left 失效时，
       才需要把 CFG.alignLeft 改成 true。 */
    if (CFG.alignLeft) html.classList.add('dv-ann-left');

    list.forEach(function(msg){
      if (mode === 'blink')        applyBlink();
      else if (mode === 'marquee') applyMarquee(msg);
      else if (mode === 'rotate')  applyRotate(msg);
      else if (mode === 'shine')   applyShine(msg);
    });
  }

  /* hash 变了就重跑（预览时手动切模式） */
  window.addEventListener('hashchange', initAnnounce);

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAnnounce);
  } else { initAnnounce(); }
})();

